import { useRef, useEffect } from 'react';

import GAException from 'src/components/GAException';

export default function useIsMountedRef() {
  const isMounted = useRef(true);

  useEffect(() => () => {
    isMounted.current = false;
  }, []);

  return isMounted;
}
